import React from 'react'
import { observer } from 'mobx-react'
import { dateFormat } from 'helpers/date'
import { classNames as cn } from 'helpers'
import st from './ModalWorkshopClose.module.scss'
import asideModalStore from 'Stores/asideModalStore'

const ModalWorkshopClose = (props) => {
  const { modalValues: modalValue, changeValue, formErrors } = asideModalStore

  const workshops = props.workshops.map((ws) => ({
    ...ws,
    date: new Date(`${ws.date}T${ws.start_at}`),
  }))

  const onClickDay = (ws) => {
    const index = workshops.findIndex((x) => x.id === ws.id)
    const newValue = workshops.map((x) => x.id).slice(index)

    changeValue(newValue, 'workshop_id')

    // Сбрасываем ошибку при выборе даты
    if (formErrors.includes('workshop_id') && newValue.length > 0) {
      asideModalStore.formErrors = formErrors.filter((e) => e !== 'workshop_id')
    }
  }

  return (
    <div className={st.container}>
      <div className={st.label}>Выберите дату закрытия расписания</div>
      <div className={st.days}>
        {workshops.map((ws) => (
          <div
            key={ws.id}
            className={cn({
              [st.day]: true,
              [st.dayGood]: !modalValue?.workshop_id?.includes(ws.id),
              [st.dayBad]: modalValue?.workshop_id?.includes(ws.id),
            })}
            onClick={() => onClickDay(ws)}
          >
            {dateFormat(ws.date, 'dd.mm.YYYY')}
          </div>
        ))}
      </div>
      {formErrors.includes('workshop_id') && (
        <div className={st.error}>
          Пожалуйста, выберите хотя бы одну дату, чтобы закрыть расписание
        </div>
      )}
    </div>
  )
}

export default observer(ModalWorkshopClose)
